import { render, staticRenderFns } from "./AOwnerDetailAppUser.vue?vue&type=template&id=96b4aca2&scoped=true"
import script from "./AOwnerDetailAppUser.vue?vue&type=script&lang=js"
export * from "./AOwnerDetailAppUser.vue?vue&type=script&lang=js"
import style0 from "./AOwnerDetailAppUser.vue?vue&type=style&index=0&id=96b4aca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b4aca2",
  null
  
)

export default component.exports